/**
 * SpreadsheetOptions
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Contains default options for spreadsheet
 * content blocks
 */
const SpreadsheetOptions = {
  /**
   * Fixed number of columns in a spreadsheet
   */
  COLUMNS: 20
};

export default SpreadsheetOptions;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/spreadsheet/SpreadsheetOptions.js